import { render, staticRenderFns } from "./AccessInformation.vue?vue&type=template&id=949bfea0"
import script from "./AccessInformation.vue?vue&type=script&lang=ts"
export * from "./AccessInformation.vue?vue&type=script&lang=ts"
import style0 from "./AccessInformation.vue?vue&type=style&index=0&id=949bfea0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('949bfea0')) {
      api.createRecord('949bfea0', component.options)
    } else {
      api.reload('949bfea0', component.options)
    }
    module.hot.accept("./AccessInformation.vue?vue&type=template&id=949bfea0", function () {
      api.rerender('949bfea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/ClientRightSide/AccessInformation.vue"
export default component.exports